import React from 'react';
import PropTypes from 'prop-types';
import { ResourceOverviewToolbarContext } from '~/modules/resource-management/ResourcingOverview/hooks';
import { useResourceManagementDashboardContextValue } from './hooks/useResourceManagementDashboardContext';

const ResourceManagementDashboardContextProvider = ({ children }) => {
  const contextValues = useResourceManagementDashboardContextValue();

  return (
    <ResourceOverviewToolbarContext.Provider value={contextValues}>
      {children}
    </ResourceOverviewToolbarContext.Provider>
  );
};

ResourceManagementDashboardContextProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default ResourceManagementDashboardContextProvider;
